import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { AnalyticsRoutingModule } from './analytics-routing.module';
import { AnalyticsComponent } from './analytics.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { ReportItemComponent } from './components/report-item/report-item.component';
import { ReportViewerComponent } from './components/report-viewer/report-viewer.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { SensorsComponent } from './pages/sensors/sensors.component';
import { SustainabilityComponent } from './pages/sustainability/sustainability.component';
import { PowerBiEmbedComponent } from './components/power-bi-embed/power-bi-embed.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    AnalyticsRoutingModule,
    ReactiveFormsModule,
  ],
  declarations: [
    AnalyticsComponent,
    ReportsComponent,
    ReportItemComponent,
    DynamicFormComponent,
    ReportViewerComponent,
    SustainabilityComponent,
    SensorsComponent,
    PowerBiEmbedComponent,
  ],
})
export class AnalyticsModule {}
